import { createContext, useContext, useState } from "react";

const LoginModalContext = createContext(null);

export function LoginModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openLogin = () => setOpen(true);
  const closeLogin = () => setOpen(false);
  return (
    <LoginModalContext.Provider value={{ open, setOpen, openLogin, closeLogin }}>
      {children}
    </LoginModalContext.Provider>
  );
}

export const useLoginModal = () => useContext(LoginModalContext);
